'use strict';

var React = require('react');

var SvgGiftCardMinor = function SvgGiftCardMinor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7.125 10.5h.636c-.48.513-1.045.926-1.617 1.008a.75.75 0 0 0 .212 1.485c1.144-.164 2.044-.955 2.61-1.587.102-.114.197-.228.284-.337.087.11.182.223.285.337.565.632 1.465 1.423 2.609 1.586a.75.75 0 0 0 .212-1.485c-.572-.081-1.137-.494-1.617-1.007h.636c1.036 0 1.875-.84 1.875-1.875a1.883 1.883 0 0 0-1.885-1.875 1.9 1.9 0 0 0-1.577.842l-.538.806-.538-.806a1.9 1.9 0 0 0-1.577-.842 1.883 1.883 0 0 0-1.885 1.875c0 1.036.84 1.875 1.875 1.875Zm-.375-1.875c0-.199.17-.375.385-.375a.4.4 0 0 1 .33.174l.384.576h-.724a.375.375 0 0 1-.375-.375Zm4.625.375h-.724l.385-.576a.4.4 0 0 1 .33-.174c.215 0 .384.176.384.375a.375.375 0 0 1-.375.375Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M17.5 6v8a2 2 0 0 1-2 2h-11a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h11a2 2 0 0 1 2 2Zm-7.5-.5h5.5a.5.5 0 0 1 .5.5v3h-1.75a.75.75 0 0 0 0 1.5h1.75v3.5a.5.5 0 0 1-.5.5h-5.5v-.75a.75.75 0 0 0-1.5 0v.75h-4a.5.5 0 0 1-.5-.5v-3.5h.25a.75.75 0 0 0 0-1.5h-.25v-3a.5.5 0 0 1 .5-.5h4v.25a.75.75 0 0 0 1.5 0v-.25Z"
  }));
};
SvgGiftCardMinor.displayName = "GiftCardMinor";

exports.SvgGiftCardMinor = SvgGiftCardMinor;
